const ResetModal = function () {
  this.editUser.hideModal()
  this.editUser.resetForm()
}

export default ResetModal
